import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success: 
          "border-transparent bg-success-light text-success-dark hover:bg-success-light/80",
        warning: 
          "border-transparent bg-warning-light text-warning-dark hover:bg-warning-light/80",
        error: 
          "border-transparent bg-error-light text-error-dark hover:bg-error-light/80",
        info: 
          "border-transparent bg-info-light text-info-dark hover:bg-info-light/80",
        neutral:
          "border-transparent bg-muted text-muted-foreground hover:bg-muted/80",
        // Variant aditiva inspirada en migro.pt: chip/tagline verde claro,
        // sobrio, sin border y rounded-md (override del rounded-full base).
        // Usar para pills de hero, taglines y badges trust en landings.
        "migro-light":
          "border-0 bg-[rgba(22,163,74,0.1)] text-green-700 hover:bg-[rgba(22,163,74,0.15)] shadow-none rounded-md font-medium",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
